import { OptionsConstants as options } from '../../config/constants/OptionsConstants';

export const PageDataState = {
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        types: {
            type: 'select',
            id: 'types',
            label: 'ระดับสิทธิ์',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },

        eec_model_type_a_student: {
            type: 'radio',
            id: 'eec_model_type_a_student',
            label: 'ข้อมูลนักศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
        eec_model_type_a_import: {
            type: 'radio',
            id: 'eec_model_type_a_import',
            label: 'นำเข้าไฟล์',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },

        eec_model_type_b_eb1: {
            type: 'radio',
            id: 'eec_model_type_b_eb1',
            label: 'เสนอหลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
        eec_model_type_b_eb2: {
            type: 'radio',
            id: 'eec_model_type_b_eb2',
            label: 'ขออนุมัติจัดอบรม',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
        eec_model_type_b_eb3: {
            type: 'radio',
            id: 'eec_model_type_b_eb3',
            label: 'ผลการอบรม',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },

        demand_supply_manpower: {
            type: 'radio',
            id: 'demand_supply_manpower',
            label: 'ความต้องการกำลังคน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
        demand_supply_resource: {
            type: 'radio',
            id: 'demand_supply_resource',
            label: 'ผลผลิตกำลังคน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
        demand_supply_matching: {
            type: 'radio',
            id: 'demand_supply_matching',
            label: 'จับคู่ความต้องการกำลังคน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
        
        publicize_news: {
            type: 'radio',
            id: 'publicize_news',
            label: 'ข่าวสาร',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
        publicize_academy_and_course: {
            type: 'radio',
            id: 'publicize_academy_and_course',
            label: 'สถาบัน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
        publicize_vacancies: {
            type: 'radio',
            id: 'publicize_vacancies',
            label: 'ประชาสัมพันธ์ตำแหน่งงาน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },

        eec_nets: {
            type: 'radio',
            id: 'eec_nets',
            label: 'ศูนย์เครือข่าย',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
        
        enterprise: {
            type: 'radio',
            id: 'enterprise',
            label: 'ผู้ประกอบการ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
        academy: {
            type: 'radio',
            id: 'academy',
            label: 'สถานศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
        external_user: {
            type: 'radio',
            id: 'external_user',
            label: 'ผู้ใช้งานภายนอก',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
        users: {
            type: 'radio',
            id: 'users',
            label: 'ผู้ใช้งาน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },

        permission: {
            type: 'radio',
            id: 'permission',
            label: 'สิทธิ์การเข้าใช้งาน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
    },
    InputGroup: {
        
        Radio: {
            eec_model_type_a_student: {
                display: 'inline',
                inputs: options.status.users_task_permission.options,
            },
            eec_model_type_a_import: {
                display: 'inline',
                inputs: options.status.users_task_permission.options,
            },

            eec_model_type_b_eb1: {
                display: 'inline',
                inputs: options.status.users_task_permission.options,
            },
            eec_model_type_b_eb2: {
                display: 'inline',
                inputs: options.status.users_task_permission.options,
            },
            eec_model_type_b_eb3: {
                display: 'inline',
                inputs: options.status.users_task_permission.options,
            },

            demand_supply_manpower: {
                display: 'inline',
                inputs: options.status.users_task_permission.options,
            },
            demand_supply_resource: {
                display: 'inline',
                inputs: options.status.users_task_permission.options,
            },
            demand_supply_matching: {
                display: 'inline',
                inputs: options.status.users_task_permission.options,
            },

            publicize_news: {
                display: 'inline',
                inputs: options.status.users_task_permission.options,
            },
            publicize_academy_and_course: {
                display: 'inline',
                inputs: options.status.users_task_permission.options,
            },
            publicize_vacancies: {
                display: 'inline',
                inputs: options.status.users_task_permission.options,
            },
            
            eec_nets:{
                display: 'inline',
                inputs: options.status.users_task_permission.options,
            },

            enterprise: {
                display: 'inline',
                inputs: options.status.users_task_permission.options,
            },
            academy: {
                display: 'inline',
                inputs: options.status.users_task_permission.options,
            },
            external_user: {
                display: 'inline',
                inputs: options.status.users_task_permission.options,
            },
            users: {
                display: 'inline',
                inputs: options.status.users_task_permission.options,
            },
            
            permission: {
                display: 'inline',
                inputs: options.status.users_task_permission.options,
            }
        },

        // Radio: {
        //     eec_model_type_a: {
        //         display: 'inline',
        //         inputs: options.status.users_task_permission.options,
        //     },
        //     eec_model_type_b: {
        //         display: 'inline',
        //         inputs: options.status.users_task_permission.options,
        //     },
        //     pr_management: {
        //         display: 'inline',
        //         inputs: options.status.users_task_permission.options,
        //     }
        // },
    },
}